/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
  component?: keyof JSX.IntrinsicElements;
  className?: string;
};

const Container: FC<Props> = ({ children, component = "div", className }) => {
  const Component = component;
  return (
    <Component
      className={cn(
        "py-6 sm:pt-20",
        "sm:pb-5",
        "px-0 md:px-8",
        "flex flex-col min-h-screen max-w-[964px] mx-auto",
        className,
      )}
    >
      {children}
    </Component>
  );
};
export default Container;
